
export const REQUEST_RECENT_TICKETS_ACTION = 'REQUEST_RECENT_TICKETS_ACTION'
export const RECEIVE_RECENT_TICKETS_SUCCESS = 'RECEIVE_RECENT_TICKETS_SUCCESS'
export const RECEIVE_RECENT_TICKETS_FAILURE = 'RECEIVE_RECENT_TICKETS_FAILURE'

// Activities
export const REQUEST_RECENT_ACTIVITY_ACTION = 'REQUEST_RECENT_ACTIVITY_ACTION'
export const RECEIVE_RECENT_ACTIVITY_SUCCESS = 'RECEIVE_RECENT_ACTIVITY_SUCCESS'
export const RECEIVE_RECENT_ACTIVITY_FAILURE = 'RECEIVE_RECENT_ACTIVITY_FAILURE'
